<ngx-loading [show]="loading"></ngx-loading>

<div class="modal-header border-0 p-0">
  <button
    type="button"
    class="btn em-btn p-0 ml-auto mr-2"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  >
    <i class="fal fa-times"></i>
  </button>
</div>

<div class="container flex-1 minh-0 d-flex flex-column p-0">
  <div class="grey-two-background justify-content-center items-container">
    <h6 class="modal-title text-uppercase text-center mt-3">Add a Tip</h6>
    <div class="font-weight-bold center m-2 big-text">
      The subtotal is: {{ subTotal | currency : 'USD' : 'symbol' : '1.2-2' }}
    </div>
    <div class="mx-4 mt-3 mb-4 tip-buttons">
      <button *ngFor="let percent of tipPercents" class="btn em-btn em-btn-green" (click)="setTipFromPercent(percent)">
        <span class="big-text">{{ percent }}%</span>
        <span class="small-text"> ({{ subTotal * (percent / 100) | currency : 'USD' : 'symbol' : '1.2-2' }}) </span>
      </button>
    </div>
  </div>

  <div class="d-flex justify-content-center my-3">
    <form [formGroup]="editForm" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col text-center align-items-center">
          <h6 class="text-uppercase text-center mb-3 mt-2">Custom Tip Amount</h6>
          <div class="toggle-container mb-2 d-flex justify-content-center align-items-center">
            <mat-button-toggle-group formControlName="isDollars" aria-label="Tip Type">
              <mat-button-toggle [value]="true">Dollars</mat-button-toggle>
              <mat-button-toggle [value]="false">Percent</mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <kendo-numerictextbox
            #tipAmount
            formControlName="tipAmount"
            [spinners]="false"
            [decimals]="2"
            [min]="0"
            [format]="editForm.controls.isDollars.value ? '$ #,##0.00' : '# \\%'"
            [style.width.px]="150"
            class="mt-2"
          ></kendo-numerictextbox>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <button [disabled]="!(tipAmount.value > 0)" class="btn em-btn em-btn-green mt-3 mb-2" type="submit">
            Add Custom Tip
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
